import Immutable from 'immutable';

// constants
import {
  DOCTOR_AVAILABILITIES_CLEAR,
  DOCTOR_AVAILABILITIES_CREATE,
  DOCTOR_AVAILABILITIES_DELETE,
  DOCTOR_AVAILABILITIES_FETCH,
  DOCTOR_AVAILABILITIES_FETCH_FOR_OFFICE
} from '../constants/doctorTypes';

// lib
import httpReducer from '../lib/httpReducer';

const add = function(map, action) {
  const payload       = action.payload || {};
  const normalized    = payload.normalized;

  let newData = map.get('data') || Immutable.Map();

  if (normalized) {
    const entities               = normalized.entities || {};
    const entity                 = Immutable.fromJS(entities.doctorAvailability || {});
    const newAvailability        = entity.first();
    const date                   = newAvailability.get('date');
    const oldAvailabilityForDate = newData.get(date) || Immutable.Map();
    const newAvailabilityForDate = oldAvailabilityForDate.set(newAvailability.get('id'), newAvailability);

    newData = newData.set(date, newAvailabilityForDate);
  }

  return map.set('data', newData);
};

const groupByDate = function(map, action) {
  const payload = action.payload || {};
  const normalized = payload.normalized || {};
  const entities = normalized.entities || {};
  const entity = Immutable.fromJS(entities.doctorAvailability || {});
  const groupedItems = entity.groupBy((item) => item.get('date'));

  return map.set('data', groupedItems);
};

const remove = function(map, action) {
  const payload     = action.payload || {};
  const normalized  = payload.normalized;

  let newData = map.get('data') || Immutable.Map();

  if (normalized) {
    const entities                = normalized.entities || {};
    const entity                  = Immutable.fromJS(entities.doctorAvailability || {});
    const removedAvailability     = entity.first();
    const date                    = removedAvailability.get('date');
    const oldAvailabilityForDate  = newData.get(date) || Immutable.Map();
    const newAvailabilityForDate  = oldAvailabilityForDate.remove(removedAvailability.get('id'));

    newData = newData.set(date, newAvailabilityForDate);
  }

  return map.set('data', newData);
};

export default function(state = Immutable.Map(), action) {
  switch (action.type) {
    case DOCTOR_AVAILABILITIES_CLEAR:             return Immutable.Map();
    case DOCTOR_AVAILABILITIES_CREATE:            return httpReducer(state, action, add);
    case DOCTOR_AVAILABILITIES_DELETE:            return httpReducer(state, action, remove);
    case DOCTOR_AVAILABILITIES_FETCH:             return httpReducer(state, action, groupByDate);
    case DOCTOR_AVAILABILITIES_FETCH_FOR_OFFICE:  return httpReducer(state, action, groupByDate);
    default:                                      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/doctorAvailabilities.js